/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

import moduleTodo from "./todo/moduleTodo.js";
import moduleCalendar from "./calendar/moduleCalendar.js";
import moduleChat from "./chat/moduleChat.js";
import moduleEmail from "./email/moduleEmail.js";
import moduleAuth from "./auth/moduleAuth.js";
import moduleECommerce from "./eCommerce/moduleECommerce.js";
import moduleWarranty from "./warranty/warranty.js";
import moduleCategory from "./category/category.js";
import moduleBrand from "./brand/brand.js";
import moduleColor from "./color/color.js";
import moduleGenericProduct from "./genericProduct/genericProduct.js";
import moduleActualProduct from "./actualProduct/actualProduct.js";
import moduleActualGallery from "./actualProduct/actualGallery.js";
import moduleAgentsDocumentUpload from "./businessParties/uploadDocuments.js";
import moduleAttribute from "./attribute/attribute.js";
import moduleSpecificProduct from "./product/specificProduct.js";
import moduleAttributes from "./product/attributes.js";
import moduleConfigurableProducts from "./product/configurableProducts.js";
import moduleCountry from "./geography/country.js";
import moduleWarehouse from "./warehouse/warehouse.js";
import moduleCheckOutTransactions from "./warehouse/checkOutTransactions.js";
import moduleCheckInTransactions from "./warehouse/checkInTransactions.js";
import moduleReservation from "./warehouse/reservation.js";
import moduleDischargePermissions from "./warehouse/dischargePermissions.js";
import moduleTransferTransactions from "./warehouse/transferTransactions.js";
import moduleWarehouseHandling from "./warehouse/warehouseHandling.js";
import moduleInventoryTransaction from "./warehouse/inventoryTransaction.js";
import moduleStock from "./warehouse/stock.js";
import moduleIndividual from "./businessParties/individual.js";
import moduleLegal from "./businessParties/legal.js";
import moduleDocumentSetting from "./businessParties/documentSetting.js";
import moduleParties from "./businessParties/parties.js";
import moduleIdentityAccess from "./identityAccess/identityAccess.js";
import modulePage from "./content/page.js";
import moduleBanner from "./content/banner.js";
import modulePost from "./content/post.js";
import moduleTag from "./content/tag.js";
import modulePostcategory from "./content/postcategory.js";
import moduleComment from "./content/comment.js";
import moduleForum from "./content/forum.js";
import moduleMenu from "./content/menu.js";
import moduleFAQcategory from "./content/FAQcategory.js";
import moduleFAQ from "./content/FAQ.js";
import moduleProductCollection from "./content/productCollection.js";
import moduleAdvertisingCampaign from "./content/advertisingCampaign.js";
import moduleHRM from "./content/HRM.js";
import moduleSale from "./sale/sale.js";
import modulePricing from "./sale/price.js";
import moduleDeductionAndIncrease from "./sale/deductionAndIncrease.js";
import moduleBaseSalePrice from "./sale/baseSalePrice.js";
import moduleOrders from "./sale/order.js";
import modulePartyOrderInfo from "./sale/partyOrderInfo.js";
import moduleProductQuery from "./sale/productQuery.js";
import moduleDraftOrder from "./sale/draftOrder.js";
import moduleReturnOrder from "./sale/returnOrder.js";
import moduleBasket from "./sale/basket.js";
import moduleReports from "./sale/reports.js";
import moduleProductSegment from "./sale/productSegment.js";
import moduleBankPayments from "./sale/bankPayments.js";
import moduleSalesPartnerPlan from "./sale/SalesPartnerPlan.js";
import moduleFestival from "./promotion/festival.js";
import moduleDiscount from "./promotion/discount.js";
import moduleVoucher from "./promotion/voucher.js";
import modulePublicDiscountCode from "./promotion/publicDiscountCode.js";
import moduleUser from "./user/user.js";
import moduleRole from "./user/role.js";
import modulePermission from "./user/permission.js";
import partnerIndividuals from "./SalePartners/partnerIndividuals";
import moduleSecurityService from "../../src/auth/SecurityService";
import moduleHasPermissionExport from "../../src/directives/haspermissionexport";
import partnerLegals from "./SalePartners/PartnerLegals";
import moduleTadbirOrder from "./tadbir/order.js";
import moduleExcel from "./excel/excel.js";
import moduleRecipientsShipping from "./shipping/recipientsShipping.js";
import moduleShipping from "./shipping/shipping.js";
import moduleNotification from "./notification/notification";
import moduleContentType from "./contentType/contentType";
import moduleTheme from "./theme";
import moduleSaleTarget from "./sale/saleTarget.js";
import moduleGroupAccount from "./account/accountGroup.js";
import moduleDetailAccount from "./account/detailAccount.js";
import moduleSubsidiaryAccount from "./account/subsidiaryAccount.js";
import moduleGeneralAccount from "./account/generalAccount.js";
import moduleFloatingAccount from "./account/floatingAccount.js";
import modulePurchaseRequest from "./procurement/purchaseRequest.js";
import moduleDepartman from "./procurement/departman.js";
import moduleUnit from "./procurement/unit.js";
import { loader } from "./loader/loader";
import modulePreInvoice from "./procurement/perInvoice.js";
export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    groupAccount:moduleGroupAccount,
    detailAccount:moduleDetailAccount,
    subsidiaryAccount:moduleSubsidiaryAccount,
    generalAccount:moduleGeneralAccount,
    floatingAccount:moduleFloatingAccount,
    purchaseRequest:modulePurchaseRequest,
    perInvoice:modulePreInvoice,
    departman:moduleDepartman,
    unit:moduleUnit,
    todo: moduleTodo,
    calendar: moduleCalendar,
    partnerIndividuals: partnerIndividuals,
    partnerLegals: partnerLegals,
    chat: moduleChat,
    email: moduleEmail,
    auth: moduleAuth,
    eCommerce: moduleECommerce,

    warranty: moduleWarranty,
    category: moduleCategory,
    brand: moduleBrand,
    color: moduleColor,

    genericProduct: moduleGenericProduct,
    actualProduct: moduleActualProduct,
    attribute: moduleAttribute,
    configurableProducts: moduleConfigurableProducts,
    specificProduct: moduleSpecificProduct,

    country: moduleCountry,

    warehouse: moduleWarehouse,
    checkOutTransactions: moduleCheckOutTransactions,
    checkInTransactions: moduleCheckInTransactions,
    reservation: moduleReservation,
    dischargePermissions: moduleDischargePermissions,
    transferTransactions: moduleTransferTransactions,
    warehouseHandling: moduleWarehouseHandling,
    inventoryTransaction: moduleInventoryTransaction,
    stock: moduleStock,
    sale: moduleSale,
    individual: moduleIndividual,
    legal: moduleLegal,
    page: modulePage,
    banner: moduleBanner,
    post: modulePost,
    tag: moduleTag,
    postcategory: modulePostcategory,
    comment: moduleComment,
    forum: moduleForum,
    menu: moduleMenu,
    FAQcategory: moduleFAQcategory,
    FAQ: moduleFAQ,
    productCollection: moduleProductCollection,
    advertisingCampaign: moduleAdvertisingCampaign,
    HRM: moduleHRM,

    actualGallery: moduleActualGallery,
    agentsDocumentUpload: moduleAgentsDocumentUpload,
    price: modulePricing,
    deductionAndIncrease: moduleDeductionAndIncrease,
    baseSalePrice: moduleBaseSalePrice,
    parties: moduleParties,
    identityAccess: moduleIdentityAccess,

    order: moduleOrders,
    partyOrderInfo: modulePartyOrderInfo,
    productQuery: moduleProductQuery,
    draftOrder: moduleDraftOrder,
    returnOrder: moduleReturnOrder,
    basket: moduleBasket,
    reports: moduleReports,
    productSegment: moduleProductSegment,
    bankPayments: moduleBankPayments,
    festival: moduleFestival,
    discount: moduleDiscount,
    voucher: moduleVoucher,
    publicDiscountCode: modulePublicDiscountCode,
    attributes: moduleAttributes,
    documentSetting: moduleDocumentSetting,
    SalesPartnerPlan: moduleSalesPartnerPlan,

    user: moduleUser,
    role: moduleRole,
    permission: modulePermission,
    securityService: moduleSecurityService,
    hasPermissionExport: moduleHasPermissionExport,

    tadbirOrder: moduleTadbirOrder,

    excel: moduleExcel,
    recipientsShipping: moduleRecipientsShipping,
    shipping: moduleShipping,
    notification: moduleNotification,
    loader,
    contentType: moduleContentType,
    theme: moduleTheme,
    saleTarget: moduleSaleTarget,
  },
  strict: process.env.NODE_ENV !== "production",
});
